<template>
  <el-dialog
    v-el-drag-dialog
    :modal="false"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.OperationLog')"
    :width="isExpand?'450px':'0px'"
    top="20vh"
    :close-on-click-modal="false"
    :class="'data-update-log-dialog el-dialog__wrapper__pure' + (hideWindow ? ' hide-window' : '') + (isExpand ? '' : ' sop-state-dialog-pack-up')"
    @close="handleClose"
  >
    <el-form style="display: flex;flex-direction: column;flex:1 1 auto;height: 100%;overflow: auto" :inline="true" label-width="90px" label-position="left" @submit.native.prevent>
      <!-- 查询按钮 -->
      <el-form-item style="width: 100%">
        <div style="display: flex;flex-direction: row;justify-content: center">
          <el-input v-model="searchText" clearable style="width: 80%" :placeholder="$t('CargoMsg.Cargo_ResultsDisplayedInYellow')" @keyup.enter.native="findText" />
          <el-button style="margin-left: 5px" type="primary" @click="findText">{{ $t('common.btn.query') }}</el-button>
        </div>
      </el-form-item>
      <!--操作日志内容-->
      <div ref="scrollContainer" style="padding-bottom: 10px; display: flex;flex-direction: column;flex:1 1 auto;height: 100px;overflow-y: auto;" @scroll="handleScroll">
        <ul class="find-text-area" style="height: 100%">
          <li v-for="(item, index) in actionLogData" :key="index">
            <div class="item">
              <div style="cursor: pointer;" @click="actionLogClick(item)">
                <div style="display: flex;justify-content: space-between;">
                  <div style="display: flex;cursor: pointer">
                    <div v-if="currentId === item.id" style="width: 14px;height: 14px;background-color: #6ABCE1;border-radius: 50%;display: inline-block" />
                    <div v-else style="width: 14px;height: 14px;background-color: #DEE6EE;border-radius: 50%;display: inline-block" />
                    <span style="margin-left: 20px">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', item.operationBy, 'chineseName') + ' ' +
                      ActionLogUtil.getOperationTypeName(item.operationType) }}</span>
                  </div>
                  <span style="margin-right: 20px">{{ item.operationTime }}</span>
                </div>
                <div style="display: flex; justify-content: space-between;margin-top: 5px">
                  <span style="margin-left: 35px">{{ $t('CargoMsg.Cargo_ChangeLocation') + '：' + item.operationSourceName }}</span>
                  <i v-show="item.isExpand === false" class="el-icon-arrow-right" style="margin-right: 20px" />
                </div>
              </div>
              <data-update-log-detail v-if="item.isExpand === true" style="margin-left: 35px" :detail="item.actionItems" />
              <div style="display: flex; flex-direction: row-reverse; margin-right: 20px; cursor: pointer;" @click="actionLogClick(item)">
                <i v-show="item.isExpand === true" class="el-icon-arrow-down" />
              </div>
            </div>
          </li>
          <!--CARGO-40129 操作日志，显示所有的信息-->
          <div v-show="shouldShow" :key="job.uuid" ref="loadMoreContainer" class="load-more">
            <div v-if="!isAllLoaded && hasMore" class="load-more-btn">{{ $t('CargoMsg.Cargo_LoadMore') }}</div>
            <div v-else-if="isAllLoaded && !hasMore" class="no-more-data">{{ $t('CargoMsg.Cargo_NoMoreData') }}</div>
          </div>
          <cargo-ag-grid-no-row-overlay v-if="!actionLogData || actionLogData.length<=0" />
        </ul>
      </div>

    </el-form>
  </el-dialog>
</template>
<script>
import dataUpdateLogDetail from '@/components/Cargo/Job/dataUpdateLogDetail'
import { getLoading } from '@/utils/utilBaseElement'
import { queryByJouUuidPage } from '@/api/actionLog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ActionLogUtil } from '@/class/cargo/model/utils/ActionLogUtil'
import { getActionLogAttribute } from '@/utils/ActionLogAttributeConstants'
import lodash from 'lodash'
import CargoAgGridNoRowOverlay from '@/components/Cargo/Common/CargoAgGridNoRowsOverLay'
import { LOG_OPERATION_TYPE_ADD, LOG_OPERATION_TYPE_DELETE } from '@/class/cargo/model/parameters/SystemConstants'
import { loadCharges } from '@/api/clearing/charge'
import { User } from '@/class/model/sys/User'

export default {
  name: 'DataUpdateLogDialog',
  components: { dataUpdateLogDetail, CargoAgGridNoRowOverlay },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    hideWindow: { type: Boolean, default: false }, // 是否隐藏弹窗
    isNeedRefresh: { type: Boolean, required: true, default: false }, // 是否需要重新加载数据
    job: { type: Object, required: true }, // 弹框打开时默认传递条件
    defaultIsExpand: { type: Boolean, default: true }, // 默认是否展开
    isNeedExpand: { type: Boolean, default: false } // 是否需要展开
  },
  data() {
    return {
      innerVisible: this.visible,
      isExpand: true, // 是否展开
      searchText: null,
      actionLogData: [],
      actionLogDataBack: [],
      detail: [],
      currentId: 0,
      ColumnUtils: ColumnUtils,
      TYPE_NAMES: TYPE_NAMES,
      ActionLogUtil: ActionLogUtil,
      privilege: {
        queryArAllRole: this.$checkPermission(['role_Charge_queryArAll']),
        queryArDeptChargeRole: this.$checkPermission(['role_Charge_queryArDeptCharge']),
        queryArUserChargeRole: this.$checkPermission(['role_Charge_queryArUserCharge']),
        queryApAllRole: this.$checkPermission(['role_Charge_queryApAll']),
        queryApDeptChargeRole: this.$checkPermission(['role_Charge_queryApDeptCharge']),
        queryApUserChargeRole: this.$checkPermission(['role_Charge_queryApUserCharge']),
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']), // 是否有应收受控费用权限
        isControlled: this.$checkPermission(['button_Charge_controlled']) // 是否有应付受控费用权限
      },
      isAllLoaded: false, // 是否加载完所有数据
      currentPage: 1, // 当前页码
      pageSize: 30, // 每页显示的记录数
      total: 0, // 数据总数
      hasMore: true, // 是否还有更多数据
      shouldShow: false,
      scrollThrottleTimeout: null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.initPageParam()
          this.isExpand = this.defaultIsExpand
          this.reloadData()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    isNeedRefresh(newVal) {
      if (newVal) {
        this.initPageParam()
        this.reloadData()
      }
    },
    'job.uuid': {
      immediate: true,
      handler: function(val) {
        if (this.visible) {
          this.initPageParam()
          this.reloadData()
        }
      },
      deep: true
    },
    isNeedExpand(newVal) {
      if (newVal) {
        this.isExpand = true
        // this.$emit('update:isNeedExpand', false)
      }
    },
    searchText(val) {
      if (!val) {
        this.findText()
      }
    }
  },
  methods: {
    handleScroll() {
      // 用于取消之前通过 setTimeout 设置的定时器。
      clearTimeout(this.scrollThrottleTimeout)
      // 用于设置一个在指定延迟后执行 方法也只会在至少xx毫秒后被调用一次  将新创建的定时器的 ID 赋值给 this.scrollThrottleTimeout，这样在下一次滚动事件触发时，可以取消之前的定时器。
      this.scrollThrottleTimeout = setTimeout(() => {
        const container = this.$refs.scrollContainer
        // 判断是否为第一页
        if (container.scrollTop === 0) {
          return
        }
        // 判断是否触底
        const isAtBottom = (container.scrollHeight - (container.scrollTop + container.clientHeight)) <= 10
        if (isAtBottom) {
          // 将div展示
          this.shouldShow = true
          // 执行滚动到底部时要做的事情
          if (!this.isAllLoaded && this.hasMore) {
            setTimeout(() => {
              this.loadMore()
            }, 70)
          }
        } else {
          this.shouldShow = false
        }
      }, 100) // 节流时间可以根据需要调整
    },
    initPageParam() {
      this.isAllLoaded = false // 是否加载完所有数据
      this.currentPage = 1 // 当前页码
      this.pageSize = 30 // 每页显示的记录数
      this.total = 0 // 数据总数
      this.hasMore = true // 是否还有更多数据
      this.shouldShow = false
      this.scrollThrottleTimeout = null
    },
    loadMore() {
      if (this.hasMore) {
        this.currentPage += 1
        this.reloadData()
      }
    },
    handleClose() {
      // this.$message.warning(this.$t('Message.OpenSOPPanelNeedDoubleClick'))
      this.searchText = null
      this.actionLogData = []
      this.actionLogDataBack = []
      this.$emit('handleClose')
    },
    reloadData() {
      if (this.currentPage === 1) {
        this.actionLogData = []
        this.actionLogDataBack = []
      }
      if (!this.job || !this.job.uuid) {
        return
      }

      const loading = getLoading()
      try {
        queryByJouUuidPage(this.job.uuid, this.currentPage, this.pageSize).then(async res => {
          if (res.data && res.data.list && res.data.list.length > 0) {
            await ActionLogUtil.analyseOperationJson(res.data.list)
            let actionLogs = res.data.list
            this.total = Number(res.data.total)
            // CARGO-36855 费用页签操作日志--串入 个人、同组、受控 权限
            const chargeActionLogs = res.data.list.filter(actionLog => actionLog.objectKey === 'charge' && actionLog.operationType !== LOG_OPERATION_TYPE_DELETE.code && !actionLog.operationSource.endsWith('ChargeAdvance'))
            if (chargeActionLogs.length > 0) {
              const chargeIds = chargeActionLogs.map(actionLog => parseInt(actionLog.operationParams.split('\n')[1]))
              const charges = await loadCharges({ chargeIds: Array.from(new Set(chargeIds)) }).then(res => {
                return res.data
              })
              // 获取不满足【个人、同组 权限】的chargeIds
              if (charges && charges.length > 0) {
                // 查询同部门的人
                const departmentTeamUser = await User.getUserDepartmentTeam()
                const excludeChargeIds = []
                charges.forEach(charge => {
                  if (charge.receivable) {
                    if (charge.controlled && !this.privilege.isCostControlled) {
                      // 受控
                      excludeChargeIds.push(charge.chargeId)
                      return
                    }
                    // 应收
                    if (this.privilege.queryArAllRole) {
                      // 所有
                      return
                    } else if (this.privilege.queryArDeptChargeRole && departmentTeamUser && departmentTeamUser.length > 0) {
                      // 同组
                      if (!this.checkDepartmentTeam(charge, departmentTeamUser)) {
                        excludeChargeIds.push(charge.chargeId)
                        return
                      }
                    } else if (charge.createdBy !== this.$store.getters.userId && charge.createdBy > 0) {
                      // 个人
                      excludeChargeIds.push(charge.chargeId)
                      return
                    }
                  } else {
                    if (charge.controlled && !this.privilege.isControlled) {
                      // 受控
                      excludeChargeIds.push(charge.chargeId)
                      return
                    }
                    // 应付
                    if (this.privilege.queryApAllRole) {
                      // 所有
                      return
                    } else if (this.privilege.queryApDeptChargeRole && departmentTeamUser && departmentTeamUser.length > 0) {
                      // 同组
                      if (!this.checkDepartmentTeam(charge, departmentTeamUser)) {
                        excludeChargeIds.push(charge.chargeId)
                        return
                      }
                    } else if (charge.createdBy !== this.$store.getters.userId && charge.createdBy > 0) {
                      // 个人
                      excludeChargeIds.push(charge.chargeId)
                      return
                    }
                  }
                })
                // 将excludeChargeIds排除
                if (excludeChargeIds.length > 0) {
                  actionLogs = res.data.list.filter(actionLog => !(actionLog.objectKey === 'charge' && excludeChargeIds.includes(parseInt(actionLog.operationParams.split('\n')[1]))))
                }
              }
            }

            for (const actionLog of actionLogs) {
              actionLog.isExpand = false
              // 设置 位置
              actionLog.operationSourceName = await ActionLogUtil.getOperationSourceNameDialog(actionLog)
              // 详情区域：fieldName、label处理
              if (actionLog.actionItems && actionLog.actionItems.length > 0) {
                if (actionLog.operationType === LOG_OPERATION_TYPE_ADD.code) {
                  actionLog.actionItems = actionLog.actionItems.filter(item => {
                    const attribute = getActionLogAttribute(item.attributeKey)
                    // 新增时，有些字段后端会赋值初始值0，而其值在前端没有意义，该记录不展示（zeroMeaningLess：true-无意义，默认无值-有意义）
                    return !(attribute && attribute.labelFunc && attribute.zeroMeaningLess && item.newValue === '0')
                  })
                }
                for (const item of actionLog.actionItems) {
                  if (item.attributeKey === 'fileHistory.FILE_NAME') {
                    item.content = this.$t('CargoMsg.Cargo_FileDelete') + '《' + item.newValue + '》'
                    continue
                  }
                  const attribute = getActionLogAttribute(item.attributeKey)
                  if (attribute) {
                    item.fieldName = attribute.fieldName
                    if (attribute.labelFunc) {
                      // console.log('item.fieldName: ' + item.fieldName)
                      if (item.oldValue !== null && item.oldValue !== '') {
                        item.oldValueLabel = await attribute.labelFunc(item.oldValue)
                        if ((item.oldValueLabel === null || item.oldValueLabel === '' || item.oldValueLabel === 'undefined' || item.oldValueLabel === '状态未知' || item.oldValueLabel === 'Status unknown') && !isNaN(parseInt(item.oldValue))) {
                          item.oldValueLabel = await attribute.labelFunc(parseInt(item.oldValue))
                        }
                        // const oldLabel = CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', parseInt(item.oldValue), 'auto_0')
                        // console.log('oldLabel:' + oldLabel)
                      }
                      if (item.newValue !== null && item.newValue !== '') {
                        item.newValueLabel = await attribute.labelFunc(item.newValue)
                        if ((item.newValueLabel === null || item.newValueLabel === '' || item.newValueLabel === 'undefined' || item.newValueLabel === '状态未知' || item.newValueLabel === 'Status unknown') && !isNaN(parseInt(item.newValue))) {
                          item.newValueLabel = await attribute.labelFunc(parseInt(item.newValue))
                        }
                        // const newLabel = CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', parseInt(item.newValue), 'auto_0')
                        // console.log('newLabel:' + newLabel)
                      }
                    } else {
                      item.oldValueLabel = item.oldValue
                      item.newValueLabel = item.newValue
                    }
                    item.content = item.fieldName + ' : ' + (item.oldValueLabel ? item.oldValueLabel : this.$t('CargoMsg.Empty')) + ' -----> ' + (item.newValueLabel ? item.newValueLabel : this.$t('CargoMsg.Empty'))
                  }
                }
              }
            }
            if (this.currentPage === 1) {
              this.actionLogData = actionLogs
              this.actionLogDataBack = lodash.cloneDeep(actionLogs)
            } else {
              this.actionLogData.push(...actionLogs)
              this.actionLogDataBack.push(...lodash.cloneDeep(actionLogs))
            }

            // 控制是否显示更多
            if (!this.actionLogData || !this.actionLogData.length || this.actionLogData.length === this.total) {
              this.isAllLoaded = true
              this.hasMore = false
            }
            // console.log('this.actionLogData:' + JSON.stringify([...this.actionLogData]))
          }
        }).finally(() => loading.close())
      } catch (e) {

      }
    },
    actionLogClick(item) {
      if (this.currentId !== item.id) {
        this.currentId = item.id
      }
      item.isExpand = !item.isExpand
    },
    findText() {
      const searchTerm = this.searchText.trim()
      if (searchTerm) {
        const actionLogData = new Set()
        const keys = this.searchText.trim().split(/\s+/)
        const actionLogDataBack = lodash.cloneDeep(this.actionLogDataBack)
        keys.forEach((key) => {
          const reg = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
          actionLogDataBack.forEach(actionLog => {
            if (actionLog.actionItems && actionLog.actionItems.length > 0) {
              actionLog.actionItems.forEach(item => {
                if (reg.test(item.content)) {
                  item.content = item.content.replace(reg, `<span style="background-color: yellow;">$&</span>`)
                  actionLogData.add(actionLog)
                  actionLog.isExpand = true
                }
              })
            }
          })
        })
        this.actionLogData = [...actionLogData]
      } else {
        this.actionLogData = this.actionLogDataBack
      }
    },
    /**
     * 同组费用查看
     */
    checkDepartmentTeam(charge, departmentTeamUser) {
      if (!charge.createdBy || charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) {
        return true
      }
      // console.log('checkDepartmentTeam this._view.departmentTeamUser', this._view.departmentTeamUser)
      for (const userId of departmentTeamUser) {
        if (userId === charge.inputBy || userId === charge.createdBy) {
          return true
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss">
.data-update-log-dialog {
  .load-more{
    display: flex;
    align-items: center; /* 垂直居中子元素 */
    justify-content: center; /* 水平居中子元素 */
    height: 30px; /* 根据需要设置高度，可以是固定的像素值或百分比 */
  }
  .load-more-btn {
    color: #606265; /* 深灰色 */
    text-align: center; /* 水平居中文本 */
    vertical-align: middle; /* 垂直居中文本（如果内容是行内元素） */
    font-size: 15px; /* 字体大小，根据需要调整 */
    height: 30px; /* 增加高度，根据需要调整 */
    line-height: 30px; /* 设置行高与高度相同，确保垂直居中 */
    cursor: pointer;
  }
  .no-more-data {
    color: #C0C4CC; /* 浅灰色 */
    text-align: center; /* 水平居中文本 */
    vertical-align: middle; /* 垂直居中文本（如果内容是行内元素） */
    font-size: 15px; /* 字体大小，根据需要调整 */
    height: 30px; /* 增加高度，与.load-more-btn相同，以保持一致 */
    line-height: 30px; /* 设置行高与高度相同，确保垂直居中 */
  }
  .el-dialog__header {
    height: 6%;
    display: flex;
  }
  .el-dialog {
    .el-dialog__body {
      height: 94%;
    }
  }
  .el-dialog__title {
    align-self: center;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 5px;
    li {
      margin: 10px;
    }
  }
  .el-form-item__content {
    width: 100%;
  }
  .item {
    padding: 10px;
    border-bottom: 1px solid #DDE0E7;
  }
  &.hide-window {
     display: none;
   }
  &.sop-state-dialog-pack-up {
  .el-dialog__header {
    display: none;
  }
  }
  .sop-state-scrollbar {
  .el-scrollbar__wrap {
    overflow: auto;
  }
  .el-row-item {
    color: #1F75D5;
    margin-left: 35px;
    margin-bottom: 12px;
  &.el-row-item-header {
     margin-bottom: 19px;
     margin-top: 3px;
     color: #333333;
   }
  &.item-origin {
     color: #BBBBBB;
     margin-left: 0;
   }
  &.item-progress {
     color: orange;
     margin-left: 0;
   }
  &.item-complete {
     color: #1F75D5;
     margin-left: 0;
   }
  &.item-exception {
     color: red;
     margin-left: 0;
   }
  .sop-state-label {
    color: #666666;
  }
  }
  }
  &.el-dialog__wrapper__pure{
     width: 0!important;
   }
  .el-dialog {
    position: fixed;
    top: unset;
    bottom: 0;
    left: auto;
    height: 80vh;
    right: 0;
    margin-bottom: 0;
  .el-dialog__body {
    padding: 5px 0;
  }
  .el-step.is-vertical {
  .el-step__line {
    left: 5px;
  }
  .el-step__icon.is-icon {
    width: 12px;
    height: 12px;
  }
  }
  .icon-solid-circle-origin {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #BBBBBB;
  }
  .icon-solid-circle-progress {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: orange;
  }
  .icon-solid-circle-complete {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #1F75D5;
  }
  .icon-solid-circle-exception {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: red;
  }
  }
  .pack-up {
    position: absolute;
    top: calc(40vh - 30px);
    width: 20px;
    height: 60px;
    margin-left: -20px;
    background: #FFFFFF;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px #E3E3E3;
    box-shadow: 0 1px 3px #E3E3E3;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  .el-icon-arrow-right {
    margin: 20px 0 0 2px;
    font-size: 16px;
    color: black;
    cursor: pointer;
  }
  }
  .expand {
    position: fixed;
    top: 50%;
    right: 30px;
    width: 20px;
    height: 66px;
    background: #1F75D5;
    color: #FFFFFF;
    border-radius: 2px;
    font-size: 16px;
    opacity: 0.5;
  .el-icon-circle-close {
    padding: 3px 4px;
    cursor: pointer;
  }
  }
}
</style>
